import config from '@/../service/project.config.js';
export default {
  outerUrl(path: string): string {
    return process.env.NODE_ENV === 'development' ? config.backend + path : path;
  },

  innerImgUrl(path: string): string {
    return new URL(path, import.meta.url).href;
  },
  makeAbsoluteUrl(inputUrl: string, protocol = 'https://'): string {
    try {
      const url = new URL(inputUrl);
      return url.href;
    } catch {
      const absoluteUrl = new URL(`${protocol}${inputUrl}`);
      return absoluteUrl.href;
    }
  },
};
